import Unauthorize from './Unauthorize';

export default Unauthorize;